import { render, staticRenderFns } from "./FaqDetails.vue?vue&type=template&id=0015591e&scoped=true&"
import script from "./FaqDetails.vue?vue&type=script&lang=js&"
export * from "./FaqDetails.vue?vue&type=script&lang=js&"
import style0 from "./FaqDetails.vue?vue&type=style&index=0&id=0015591e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0015591e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
